<script setup lang="ts">
import { useAttrs } from "vue";
import Header from "./Header/Header.vue";
import Body from "./Body/Body.vue";

// Handle custom props for styling
interface Props {
  headerClass?: string;
  bodyClass?: string;
  bodySectionClass?: string;
}
defineProps<Props>();

// Extract and bind dynamic attributes
const attrs = useAttrs();
</script>

<template>
  <article
    v-bind="attrs"
    class="overflow-hidden bg-white shadow-xl shadow-slate-900/5 dark:bg-slate-900 sm:rounded-2xl"
  >
    <!-- Header section -->
    <Header
        :class="headerClass"
    />

    <!-- Body section -->
    <Body
        :class="bodyClass || 'px-5 py-10 sm:px-8 lg:px-12 lg:py-14'"
        :section-class="bodySectionClass || 'text-left'"
    />
  </article>
</template>
